import axios from 'axios';


const EmailService = () => {

    const axiosEmailServiceInstance = axios.create({
        baseURL: 'https://4ge5vd9hrc.execute-api.us-west-1.amazonaws.com/Stage',
        headers:{
            'Content-Type': 'application/json',
        }
    });

    const sendEmail = (senderName, senderEmail, message) =>{
        return axiosEmailServiceInstance.post('/sendemail',{
            'senderName': senderName,
            'senderEmail': senderEmail,
            'message': message
        })
    }

    return {
        sendEmail: sendEmail
    }
}

export default EmailService;






